// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"245":"component---src-pages-index-tsx","453":"component---src-pages-404-tsx"}[chunkId] || chunkId) + "-" + {"245":"05cd8b72c4815bf057c3","453":"07f28534bda39055a049","454":"f7c320f5c846aa010fed"}[chunkId] + ".js";
};